// src/hooks/termOfPayments/useForceDeleteAllTermOfPayments.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllTermOfPayments } from "../../api/apiTermOfPayments";
import parseError from "../../utils/parseError";

const useForceDeleteAllTermOfPayments = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllTermOfPaymentsMutation, isPending } = useMutation({
        mutationFn: forceDeleteAllTermOfPayments,
        onSuccess: (res) => {
            const message = res?.message || "Term of payments force deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["termOfPayments"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to force delete term of payments");
        },
    });

    return { forceDeleteAllTermOfPaymentsMutation, isPending };
};

export default useForceDeleteAllTermOfPayments;